// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3FWFk","left":"StickyBox_left__3r5Ys","right":"StickyBox_right__2G_Wn"};